import actionTypes from "_constants/actionTypes";

export const questionnaireActions = {
    endTransaction,
    getQuestionnaire,
    getQuestionnaires,
    getAssessments,
    getAssessmentsCode,
    saveAnswer,
    saveFakeAnswer,
    getAnswers,
    getAnswersV2,
    saveArea,
    getArea,
    deleteAnswer,
    getResponses,
    getResponse
};


function getArea(payload) {
    return {
        type: actionTypes.GET_AREA_STUDENT,
        payload: payload
    };
}
function getAnswers(payload) {
    return {
        type: actionTypes.GET_ANSWERS,
        payload: payload
    };
}
function getAnswersV2(payload) {
    return {
        type: actionTypes.GET_ANSWERS_V2,
        payload: payload
    };
}
function endTransaction() {
  return {
    type: actionTypes.END_TRANSACTION,
  };
}

function saveFakeAnswer(payload) {
    return {
        type: actionTypes.SAVE_ANSWER_DATA,
        payload: payload
    };
}

function saveAnswer(payload) {
    return {
        type: actionTypes.SAVE_ANSWER,
        payload: payload
    };
}



function deleteAnswer(payload) {
    return {
        type: actionTypes.DELETE_ANSWER,
        payload: payload
    };
}


function saveArea(payload) {
    return {
        type: actionTypes.SAVE_AREA,
        payload: payload
    };
}

function getQuestionnaire(payload) {
  return {
    type: actionTypes.GET_QUESTIONNAIRE,
      payload: payload
  };
}

function getQuestionnaires(payload) {
    return {
        type: actionTypes.GET_QUESTIONNAIRES,
        payload: payload
    };
}

function getAssessments(payload) {
    return {
        type: actionTypes.GET_ASSESSMENTS,
        payload: payload
    };
}


function getAssessmentsCode(payload) {
    return {
        type: actionTypes.GET_ASSESSMENTS_CODE,
        payload: payload
    };
}

function getResponses(payload) {
    return {
        type: actionTypes.GET_RESPONSES,
        payload
    }
}

function getResponse(payload) {
    return {
        type: actionTypes.GET_RESPONSE,
        payload
    }
}
